import React, { useEffect, useState } from 'react'
import Sidebar from '../Components/Sidebar';
import Header from '../Components/Header';
import { Link, useNavigate } from 'react-router';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useCategoryStore } from '../store/useCategoryStore';
import { Box, Button, Modal, Pagination, Stack, TableCell, TableRow, Typography } from '@mui/material';
import Loader from '../Components/loader/Loader';

export default function Categories() {
    const navigate = useNavigate()
    const { getAllCategory, paginatedCategory, deletecategory, loading, dowloadCategory } = useCategoryStore()
    const [loadingStyle, setLoadingStyle] = useState(false)
    const [totalPages, setTotalPages] = useState(1);
    const [pageNumber, setPageNumber] = useState(1);
    const [search, setSearch] = useState('');
    const [itemId, setItemId] = useState(null);
    const [pageSize, setPageSize] = useState(10);
    const [field, setField] = useState('');
    const [open, setOpen] = useState(false);
    const [deleteId, setDeleteID] = useState(null);

    const handleEdit = (id) => {
        navigate(`/add-category?id=${encodeURIComponent(id)}`);
    };
    const getAllCategoryFunctioncaller = async () => {
        const data = await getAllCategory(pageNumber, pageSize, search, field)
        setTotalPages(data?.totalPages)
    }

    const handleChangePagination = (event, value) => {
        console.log(event, value)
        setPageNumber(value);
    };

    const handleCancelDelete = () => {
        setOpen(false);
    };

    const handleDowload = async () => {
        setLoadingStyle(true)
        await dowloadCategory(pageNumber, pageSize, search, field)
        setLoadingStyle(false)
    }

    const handleDelete = (id) => {
        setDeleteID(id)
        setOpen(true)
    }

    const handleSearchChange = (e, field) => {
        setField(field)
        console.log(e.target.value, field)
        setPageNumber(1)
        // setLoading(true);
        setSearch(e.target.value)
    };

    const handleConfirmDelete = async () => {
        try {
            // setOpen(false)
            // setLoading(true)
            const res = await deletecategory(deleteId)
            setOpen(false)
            // if (res) {
            //     setTable(table.filter((item) => item._id !== itemId))
            // }
            // setLoading(false)
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        getAllCategoryFunctioncaller()
    }, [pageNumber, search, field])
    return (
        <div id="dashboard-root"
            className="flex min-h-[1000px] w-full">
            <Loader loading={loadingStyle} />

            <Sidebar />

            <main id="main-content" className="flex-1 px-10 py-8">

                <Header title="Categories" />
                <div id="categories-page" className="mb-6">
                    <div className="flex justify-between items-center mb-6">
                        <div>

                            <p className="text-gray-600">Manage your product categories</p>
                        </div>
                        <div className="flex space-x-3">
                            <button className="bg-white border border-gray-300 rounded-lg px-4 py-2 text-sm font-medium text-gray-700 flex items-center">
                                <i className="fa-solid fa-filter mr-2"></i>
                                Filter
                            </button>
                            <button className="bg-white border border-gray-300 rounded-lg px-4 py-2 text-sm font-medium text-gray-700 flex items-center"
                                onClick={() => handleDowload()}
                            >
                                <i className="fa-solid fa-download mr-2"></i>
                                Export
                            </button>
                            <Link to="/add-category" id="add-category-btn" class="bg-primary-600 hover:bg-primary-700 text-white rounded-lg px-4 py-2 text-sm font-medium flex items-center">
                                <i className="fa-solid fa-plus mr-2"></i>
                                Add Category
                            </Link>
                        </div>
                    </div>

                    <div className="bg-white rounded-lg shadow overflow-hidden">
                        <div className="p-4 border-b flex items-center justify-between">
                            <div className="relative">
                                <input
                                    type="text"
                                    placeholder="Search Category"
                                    onChange={(e) => handleSearchChange(e, "name")}
                                    className="border rounded-lg px-3 py-2 text-sm w-64"
                                />
                                <i className="fa-solid fa-search absolute right-3 text-gray-400" style={{ top: "0.375rem" }}></i>
                            </div>
                        </div>
                        <div className="overflow-x-auto">
                            {
                                <table className="w-full">
                                    <thead className="bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        <tr>
                                            <th className="p-4">Category</th>
                                            <th className="p-4">Status</th>
                                            <th className="p-4">Actions</th>
                                        </tr>
                                        <tr>
                                            {/* <th class="p-4">
                                                <input
                                                    type="text"
                                                    placeholder="Search Category"
                                                    onChange={(e) => handleSearchChange(e, "name")}
                                                    class="mt-1 block w-full border border-gray-300 rounded-md p-1 text-sm"
                                                />
                                            </th> */}
                                            {/* <th class="p-4">
                                                <input
                                                    type="text"
                                                    placeholder="Search Status"
                                                    onChange={(e) => handleSearchChange(e, "isFeatured")}
                                                    class="mt-1 block w-full border border-gray-300 rounded-md p-1 text-sm"
                                                />
                                            </th> */}

                                        </tr>
                                    </thead>

                                    <tbody className="divide-y divide-gray-200">
                                        {

                                            loading ? (
                                                Array.from({ length: 5 }).map((_, rowIndex) => (
                                                    <TableRow key={rowIndex}>
                                                        {Array.from({ length: 4 }).map((_, colIndex) => (
                                                            <TableCell key={colIndex}>
                                                                <Skeleton variant="text" animation="wave" />
                                                            </TableCell>
                                                        ))}
                                                    </TableRow>
                                                ))
                                            ) :
                                                ((paginatedCategory || []).map((ele, index) => (
                                                    <tr className="hover:bg-gray-50" key={index}>
                                                        <td className="p-4">
                                                            <div className="flex items-center">
                                                                {/* <div className="w-10 h-10 rounded-lg bg-teal-100 flex items-center justify-center mr-3">
                                                        {ele?.images ? (
                                                            <img
                                                                src={ele.images}
                                                                alt="Product"
                                                                className="w-full h-full object-contain rounded-lg"
                                                            />
                                                        ) : (
                                                            <span className="text-gray-400">No Image</span>
                                                        )}
                                                    </div> */}

                                                                <div className="font-medium text-gray-800">{ele?.name}</div>
                                                            </div>
                                                        </td>
                                                        {/* <td class="p-4 text-gray-600">{ele?.description}</td> */}

                                                        <td className="p-4">
                                                            {

                                                                ele?.isFeatured ? <span className="px-2 py-1 bg-green-100 text-green-800 rounded-full text-xs">Active</span> :
                                                                    <span className="px-2 py-1 bg-red-100 text-red-800 rounded-full text-xs">
                                                                        InActive</span>
                                                            }

                                                        </td>
                                                        <td className="p-4">
                                                            <div className="flex space-x-2">
                                                                <button className="text-gray-500 hover:text-primary-600"
                                                                    onClick={() => handleEdit(ele?._id)}
                                                                >
                                                                    <i className="fa-solid fa-pencil"></i>
                                                                </button>
                                                                <button className="text-gray-500 hover:text-red-600"
                                                                    onClick={() => handleDelete(ele?._id)}>
                                                                    <i className="fa-solid fa-trash"></i>
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )))
                                        }

                                    </tbody>
                                </table>
                                || <Skeleton count={10} />
                            }
                        </div>
                        <Modal
                            open={open}
                            onClose={handleCancelDelete}
                            aria-labelledby="confirm-delete-modal"
                            aria-describedby="modal-to-confirm-deletion"
                        >
                            <Box
                                sx={{
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    backgroundColor: 'white',
                                    padding: '20px',
                                    borderRadius: '5px',
                                    boxShadow: 24,
                                    width: { xs: "80%", md: "500px" },
                                    textAlign: 'center',
                                }}
                            >
                                <Typography variant="h6" gutterBottom>
                                    Are you sure you want to delete this Category?
                                </Typography>
                                <Button variant="outlined" color="#274156" onClick={handleConfirmDelete}>
                                    Yes
                                </Button>
                                <Button variant="outlined" color="#274156" onClick={handleCancelDelete} sx={{ marginLeft: '10px' }}>
                                    No
                                </Button>
                            </Box>
                        </Modal>
                        <Stack spacing={2} className="flex items-center mb-6 mt-4 ">
                            <Pagination
                                count={totalPages}
                                onChange={handleChangePagination}
                                variant="outlined"
                                shape="rounded"
                            />
                        </Stack>
                    </div>
                </div>
            </main>
        </div>
    )
}
